import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/polymerize/monographic',
  owner: '/home',
  authority: 'monographicList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};